import { AfterViewChecked, Component, ElementRef, inject, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';

import { MatDialog } from '@angular/material/dialog';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Hub } from 'aws-amplify/utils';
import { AuthService } from './services/auth.service';
import { VersionCheckService } from './services/version-check/version-check.service';
import { environment } from 'src/environments/environment';
import { HotGlobalConfigService } from '@handsontable/angular-wrapper';
import { NavbarComponent } from './navbar/navbar.component';
import { VersionCheckBannerComponent } from './shared-components/version-check-banner/version-check-banner.component';
// Necessary for Handsontable/Angular-Wrapper to work properly
// It would be more efficient to import each needed plugin separately, but this is easier
// and I do not really notice any speed difference
import { registerAllModules } from 'handsontable/registry';
registerAllModules();

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: true,
    imports: [AsyncPipe, RouterOutlet, AmplifyAuthenticatorModule, NavbarComponent, VersionCheckBannerComponent]
})
export class AppComponent implements OnInit, AfterViewChecked {
  dialog = inject(MatDialog);
  authService = inject(AuthService);
  router = inject(Router);
  versionCheckService = inject(VersionCheckService);

  stage: BehaviorSubject<string>;
  stage$: Observable<string>;
  title = 'binbase-scheduler';
  private host = inject(ElementRef);

  navigating$: Observable<boolean> = of(false);

  hotConfig = inject(HotGlobalConfigService);

  constructor() {
    Hub.listen('auth', (data) => {
      this.authService.onAuthEvent(data);
    });

    this.hotConfig.setConfig({
      license: 'non-commercial-and-evaluation',
      themeName: 'ht-theme-main',
    });
  }

  public formFields = {
    signUp: {
      family_name: {
        placeholder: 'Enter your Last Name',
        label: 'Last Name:'
      },
      name: {
        label: 'First Name:',
        placeholder: 'Enter your First Name',
      }
    },
  };

  ngOnInit() {
    console.log('app init');
    this.versionCheckService.start();
    this.stage = new BehaviorSubject<string>(environment.name !== 'prod' ? `*** VIEWING STAGE: ${environment.name.toUpperCase()} ***` : '');
    this.stage$ = this.stage.asObservable();
    this.navigating$ = this.router.events.pipe(
      filter(
        (e) =>
          e instanceof NavigationStart ||
          e instanceof NavigationEnd ||
          e instanceof NavigationCancel ||
          e instanceof NavigationError
      ),
      map(e => e instanceof NavigationStart)
    );
  }

  // Remove any aria-invalid attributes that may be added to the underlying mat-radio-button inputs
  // Accessibility scanners sometimes report these on radio inputs; remove them at runtime.
  ngAfterViewChecked(): void {
    try {
      const inputs: NodeListOf<HTMLInputElement> = this.host.nativeElement.querySelectorAll('mat-radio-button input[aria-invalid]');
      inputs.forEach((i) => i.removeAttribute('aria-invalid'));
    } catch (e) {
      // ignore DOM exceptions in environments without a DOM
    }
  }

  focusMainContent(event: Event): void {
    event.preventDefault();
    const main = this.host.nativeElement.querySelector('#main-content') as HTMLElement | null;
    if (main) {
      main.focus();
      main.scrollIntoView();
    }
  }
}
